let labelSequence = 0;

export function describeEditorControl(control, description) {
  if (!description.id) description.id = `mag-help-${++labelSequence}`;
  const ids = new Set((control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
  ids.add(description.id); control.setAttribute('aria-describedby', [...ids].join(' '));
}

// Existing editor markup places many labels directly before their controls. Keep
// the visual layout, but establish the same association for keyboards/readers.
export function connectEditorLabels(root) {
  for (const label of root.querySelectorAll('label:not([for])')) {
    if (label.querySelector('input,select,textarea')) continue;
    const control = label.nextElementSibling;
    if (!control?.matches('input,select,textarea')) continue;
    if (!control.id) control.id = `mag-control-${++labelSequence}`;
    label.htmlFor = control.id;
  }
  for (const control of root.querySelectorAll('input,select,textarea,[role="radiogroup"]')) {
    const help = control.closest('label')?.nextElementSibling || control.nextElementSibling;
    if (help?.classList.contains('mag-modal__hint')) describeEditorControl(control, help);
  }
}
